import { z } from "zod";
// A place to store extra context about the event
export const SWMetadata = z.object({
    apiKey: z.string().optional(),
    requestId: z.string().optional(),
    hostname: z.string().optional(),
    release: z.string().optional()
});
export const BaseEvent = z.object({
    id: z.string().optional(),
    metadata: SWMetadata.default({}).optional(),
    ts: z.string().optional()
});
